import { AdminDeposit } from '../models'
import { getHumanizeDate } from './date-helpers'

export const getAdminDepositUser = (deposit: AdminDeposit): string => {
  const user = `${deposit.user_name || ''} ${deposit.user_lastname || ''}`
  if (user.trim().length === 0) return '-'
  return user
}

export const getAdminDepositCompany = (deposit: AdminDeposit): string => {
  return deposit.user_company || '-'
}

export const getAdminDepositsFiltered = (bigList: AdminDeposit[], filterText: string): AdminDeposit[] => {
  let newList = bigList

  if (filterText) {
    const text = filterText.toLowerCase()
    newList = newList.filter(deposit => {
      return (
        deposit.internal_reference.toLowerCase().includes(text) ||
        getAdminDepositUser(deposit).toLowerCase().includes(text) ||
        getAdminDepositCompany(deposit).toLowerCase().includes(text) ||
        `${deposit.total}`.toLowerCase().includes(text) ||
        getHumanizeDate(deposit.created)?.toLowerCase().includes(text)
      )
    })
  }

  return newList
}
